export default __webpack_public_path__ + "static/media/2.8a8beeb7.gif";